import { Link } from "react-router-dom"
import Container from "../components/ui/Container.js"
import { useTranslation } from "react-i18next"
import "./Home.scss"
import { useEffect, useMemo, useState } from "react"
import { api } from "../services/api/index.js"
import { Loading } from "../components/ui/Loading.js"
import { getCookie, setCookieInHours } from "../helpers/cookies.js"
import { useQuery } from "../hooks/useQuery.js"
import toast from "react-hot-toast"

const MiniGame = ({ game }) => {
  const { t } = useTranslation()

  const bg = game.bg ? `url(${game.bg})` : "none"

  return (
    <Link to={game.id} className="item">
      <div className="cover box" style={{ backgroundImage: bg }} />

      <div className="details">
        <h5>{game.name}</h5>
        <span>{game.desc}</span>
      </div>
    </Link>
  )
}

const Galeria = ({ titulo, items, enabledGames }) => {
  const { t } = useTranslation()
  const isEnabled = (game) =>
    enabledGames !== null && enabledGames.find((g) => g.id === game.id)?.enabled

  return (
    <div className="gallery">
      <div className="title">{titulo}</div>
      <div className="items">
        {!enabledGames && (
          <div className="row mb-5">
            <Loading
              text={<p className="my-0 ms-2">{t("ui.btns.loading")}...</p>}
            />
          </div>
        )}

        {enabledGames &&
          items
            .filter(isEnabled)
            .map((game) => <MiniGame key={game.id} game={game} />)}
      </div>
    </div>
  )
}

const Home = () => {
  const { t } = useTranslation()
  const img = process.env.PUBLIC_URL + "/img"

  const ludicGames = [
    {
      name: "Guess the word",
      id: "guessword",
      bg: img + "/crosswords.png",
      desc: "Try to guess the word in the fewest attempts possible",
    },
    {
      name: t("home.games.crosswords.title"),
      id: "crossword",
      bg: img + "/crosswords.png",
      desc: t("home.games.crosswords.summary"),
    },
    {
      name: t("home.games.wordsearch.title"),
      id: "wordsearch",
      bg: img + "/wordsearch.png",
      desc: t("home.games.wordsearch.summary"),
    },
    {
      name: t("home.games.language_practice.title"),
      id: "language-practice",
      bg: img + "/language-practice.png",
      desc: t("home.games.language_practice.summary"),
    },
    {
      name: t("home.games.the_story_game.title"),
      id: "story",
      bg: img + "/storygame.png",
      desc: t("home.games.the_story_game.summary"),
    },
    {
      name: t("home.games.memory_card_game.title"),
      id: "memory",
      bg: img + "/memory.png",
      desc: t("home.games.memory_card_game.summary"),
    },
  ]

  const multiGames = [
    {
      name: t("home.games.sea_animals.title"),
      id: "sea-animals",
      bg: img + "/seaanimals.png",
      desc: t("home.games.sea_animals.summary"),
    },
    {
      name: t("home.games.tutti_frutti.title"),
      id: "tutti",
      bg: img + "/tutti.png",
      desc: t("home.games.tutti_frutti.summary"),
    },
  ]

  const [enabledGames, setEnabledGames] = useState(null)
  const { url, opt } = useMemo(() => api.game_management.readAll(), []),
    query = useQuery()

  // la query esta cacheada?
  useEffect(() => {
    const links = getCookie("links")
    if (links) {
      // parseo desde cookiess
      const data = JSON.parse(links)
      setEnabledGames(data)
      return
    }

    // no hay links; hago el fetch

    query.url.current = url
    query.opt.current = opt
    query.run({
      onOk: (res) => {
        const data = JSON.stringify(res)
        setCookieInHours("links", data, 1)
        setEnabledGames(res)
      },
      onErr: () => toast.error(t(`ui.msgs.something_went_wrong`)),
    })

    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Container>
        {query.err && <>{t(`ui.msgs.something_went_wrong`)}</>}
        {!query.err && (
          <>
            <Galeria
              titulo={t("home.single_player_games")}
              items={ludicGames}
              enabledGames={enabledGames}
            />
            <Galeria
              titulo={t("home.multiplayer_games")}
              items={multiGames}
              enabledGames={enabledGames}
            />
          </>
        )}
      </Container>
    </>
  )
}

export default Home
